import { useEffect } from "react";
import { bootstrapSalesforce, clearSalesforce } from "../utils/SalesforceEmbeddedMessaging";
const Salesforce = (props) => {
    const { orgId, embeddedMessagingName, baseUrl, scrt2Url, language, username } = props;
    useEffect(() => {
        if (orgId && embeddedMessagingName && baseUrl && scrt2Url) {
            bootstrapSalesforce(orgId, embeddedMessagingName, baseUrl, scrt2Url, language ?? "en_US", username);
        }
        return () => {
            clearSalesforce();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return props.children || null;
};
Salesforce.displayName = "Salesforce";
export default Salesforce;
//# sourceMappingURL=Salesforce.js.map